import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex flex-wrap items-center gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-300 mx-1">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {isLast || !item.href ? (
                <span className={isLast ? 'text-foreground-700 font-medium' : 'text-foreground-400'}>
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}